// extracted by mini-css-extract-plugin
export default {"zoomModal":"H4-z"};